import qs from 'qs';

import { handleJSON } from '@/utils/fetch-utils';
import { headers } from './index';
import transformDownloadClassesParams from './adapters/download-classes-adapter';

const { API_URL, LIVE_INSTRUCTION_API_URL } = process.env;
const qsParams = {
  addQueryPrefix: true,
  arrayFormat: 'comma',
  encode: false,
  indices: false,
  skipNulls: true,
};

export default {
  endpoints: {
    classes: query => `${LIVE_INSTRUCTION_API_URL}/v0/calendar/classes/all${query}`,
    download: (tutorId, query) => `${API_URL}/teachers/${tutorId}/classes/download-reports/${query}`,
    pendingFeedbacks: query => `${LIVE_INSTRUCTION_API_URL}/v0/teacher/calendar/classes/pending-feedbacks${query}`,
  },

  fetchClasses({ ordering, ...params }) {
    const translatedParams = { ...params };
    if (ordering) {
      translatedParams.order_by = ordering;
    }

    const query = qs.stringify(translatedParams, qsParams);
    const endpoint = this.endpoints.classes(query);

    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  downloadClasses(tutorId, params) {
    const transformedParams = transformDownloadClassesParams(params);
    const query = qs.stringify(transformedParams, qsParams);
    const endpoint = this.endpoints.download(tutorId, query);

    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchPendingFeedbacks(params) {
    const query = qs.stringify(params, qsParams);
    const endpoint = this.endpoints.pendingFeedbacks(query);

    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },
};
